var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _TokenHandler_instances, _TokenHandler_pubSub, _TokenHandler_pubNub, _TokenHandler_tokenRefreshTimeoutMs, _TokenHandler_isChannelOwner, _TokenHandler_tokenRefreshPromise, _TokenHandler_s10ChannelId, _TokenHandler_onTokenExpired, _TokenHandler_rejectAndClearTokenRefreshPromise, _TokenHandler_resolveAndClearTokenRefreshPromise;
import globalLogger from "@lazarentertainment/js-logger";
import { defer, timeout } from "./util/promiseUtils";
export const DEFAULT_REFRESH_TIMEOUT_MS = 15000;
/**
 * This utility encapsulates a bunch of state related to token expiry
 * handling, so that it can be easily tested. It serves a few functions:
 *  - Accepts a token and schedules a `tokenExpiry` event for when that
 *    token will expire.
 *  - Inspects the token to determine if the chat user is the owner of
 *    the Stage TEN channel
 *  - Exposes a `tokenRefreshPromise` which the caller can wait for. This
 *    will resolve when a new token is set.
 *  - Allows the caller to manually trigger `tokenExpiry`, for example
 *    if they receive an auth error.
 */
export class TokenHandler {
    constructor(pubNub, pubSub, { tokenRefreshTimeoutMs = DEFAULT_REFRESH_TIMEOUT_MS, s10ChannelId, onTokenExpired, }) {
        _TokenHandler_instances.add(this);
        _TokenHandler_pubSub.set(this, void 0);
        _TokenHandler_pubNub.set(this, void 0);
        _TokenHandler_tokenRefreshTimeoutMs.set(this, void 0);
        _TokenHandler_isChannelOwner.set(this, false);
        _TokenHandler_tokenRefreshPromise.set(this, void 0);
        _TokenHandler_s10ChannelId.set(this, void 0);
        _TokenHandler_onTokenExpired.set(this, void 0);
        __classPrivateFieldSet(this, _TokenHandler_pubNub, pubNub, "f");
        __classPrivateFieldSet(this, _TokenHandler_pubSub, pubSub, "f");
        __classPrivateFieldSet(this, _TokenHandler_tokenRefreshTimeoutMs, tokenRefreshTimeoutMs, "f");
        __classPrivateFieldSet(this, _TokenHandler_s10ChannelId, s10ChannelId, "f");
        __classPrivateFieldSet(this, _TokenHandler_onTokenExpired, onTokenExpired, "f");
    }
    get isChannelOwner() {
        return __classPrivateFieldGet(this, _TokenHandler_isChannelOwner, "f");
    }
    get tokenRefreshPromise() {
        var _a;
        return (_a = __classPrivateFieldGet(this, _TokenHandler_tokenRefreshPromise, "f")) !== null && _a !== void 0 ? _a : Promise.resolve();
    }
    setToken(token) {
        // The PubNub access token may be cached on a server, so triggering
        // a refresh doesn't actually guarantee a new token. We check the
        // token here to avoid scheduling redundant token expiry events.
        if (token === __classPrivateFieldGet(this, _TokenHandler_pubNub, "f").getToken()) {
            globalLogger.V1("PubNub token was unchanged, returning...");
            return;
        }
        globalLogger.V1("Setting new PubNub token");
        __classPrivateFieldGet(this, _TokenHandler_pubNub, "f").setToken(token);
        __classPrivateFieldGet(this, _TokenHandler_instances, "m", _TokenHandler_resolveAndClearTokenRefreshPromise).call(this);
        const parsedToken = __classPrivateFieldGet(this, _TokenHandler_pubNub, "f").parseToken(token);
        const wasChannelOwner = __classPrivateFieldGet(this, _TokenHandler_isChannelOwner, "f");
        __classPrivateFieldSet(this, _TokenHandler_isChannelOwner, !!parsedToken && isChannelOwner(parsedToken, __classPrivateFieldGet(this, _TokenHandler_s10ChannelId, "f")), "f");
        if (wasChannelOwner !== __classPrivateFieldGet(this, _TokenHandler_isChannelOwner, "f")) {
            __classPrivateFieldGet(this, _TokenHandler_pubSub, "f").publish("isChannelOwner", __classPrivateFieldGet(this, _TokenHandler_isChannelOwner, "f"));
        }
        __classPrivateFieldGet(this, _TokenHandler_pubNub, "f").reconnect();
    }
    triggerTokenExpired() {
        if (__classPrivateFieldGet(this, _TokenHandler_tokenRefreshPromise, "f")) {
            globalLogger.V1("PubNub token refresh already under way, returning...");
            return;
        }
        globalLogger.V1("Triggering PubNub token refresh flow");
        __classPrivateFieldSet(this, _TokenHandler_tokenRefreshPromise, defer(), "f");
        const refreshPromiseWithTimeout = timeout(__classPrivateFieldGet(this, _TokenHandler_tokenRefreshPromise, "f"), __classPrivateFieldGet(this, _TokenHandler_tokenRefreshTimeoutMs, "f"));
        __classPrivateFieldGet(this, _TokenHandler_onTokenExpired, "f").call(this);
        refreshPromiseWithTimeout
            .catch((error) => {
            __classPrivateFieldGet(this, _TokenHandler_instances, "m", _TokenHandler_rejectAndClearTokenRefreshPromise).call(this, error);
        })
            .finally(() => {
            __classPrivateFieldSet(this, _TokenHandler_tokenRefreshPromise, undefined, "f");
        });
    }
    reset() {
        __classPrivateFieldGet(this, _TokenHandler_instances, "m", _TokenHandler_rejectAndClearTokenRefreshPromise).call(this);
    }
}
_TokenHandler_pubSub = new WeakMap(), _TokenHandler_pubNub = new WeakMap(), _TokenHandler_tokenRefreshTimeoutMs = new WeakMap(), _TokenHandler_isChannelOwner = new WeakMap(), _TokenHandler_tokenRefreshPromise = new WeakMap(), _TokenHandler_s10ChannelId = new WeakMap(), _TokenHandler_onTokenExpired = new WeakMap(), _TokenHandler_instances = new WeakSet(), _TokenHandler_rejectAndClearTokenRefreshPromise = function _TokenHandler_rejectAndClearTokenRefreshPromise(error) {
    var _a;
    (_a = __classPrivateFieldGet(this, _TokenHandler_tokenRefreshPromise, "f")) === null || _a === void 0 ? void 0 : _a.reject(error);
    __classPrivateFieldSet(this, _TokenHandler_tokenRefreshPromise, undefined, "f");
}, _TokenHandler_resolveAndClearTokenRefreshPromise = function _TokenHandler_resolveAndClearTokenRefreshPromise() {
    var _a;
    (_a = __classPrivateFieldGet(this, _TokenHandler_tokenRefreshPromise, "f")) === null || _a === void 0 ? void 0 : _a.resolve();
    __classPrivateFieldSet(this, _TokenHandler_tokenRefreshPromise, undefined, "f");
};
function isChannelOwner(token, s10ChannelId) {
    if (!token.meta ||
        typeof token.meta !== "object" ||
        !("roles" in token.meta) ||
        !Array.isArray(token.meta.roles)) {
        return false;
    }
    return token.meta.roles.some((role) => role &&
        role.type === "channel" &&
        role.role === "owner" &&
        role.id === s10ChannelId);
}
